//@ts-ignore
// @ts-nocheck
import { applySnapshot, getParent, getSnapshot, types } from "mobx-state-tree";

const FilterStore = types
  .model("FilterStore", {
    gender: types.optional(types.array(types.string), ["male", "female"]),
    sortBy: types.optional(types.string, "Recommended"),
    showPremium: types.optional(types.boolean, false),
    lessonType: types.optional(types.string, "physical"),
    minPrice: types.optional(types.number, 0),
    maxPrice: types.optional(types.number, 0),
    maxAge: types.optional(types.number, 0),
    minAge: types.optional(types.number, 18),
    educationDegrees: types.optional(types.array(types.string), []),
    educationCountries: types.optional(types.array(types.string), []),
    educationGrades: types.optional(types.array(types.string), []),
    minExperience: types.optional(types.string, ""),
    isFlexible: types.optional(types.boolean, false),
    tutorPoolOnly: types.optional(types.boolean, false),
  })
  .views((self) => {
    return {
      get defaultFilters() {
        const defaultValues = getSnapshot(self);
        return defaultValues;
      },

      get resultIsFiltered() {
        return true;
      },
    };
  })
  .actions((self) => {
    return {
      updateData(filterData) {
        applySnapshot(self, {
          ...getSnapshot(self),
          ...filterData,
        });
      },

      resetFilters() {
        const parent = getParent(self, 2);
        applySnapshot(self, {});
        parent.oldSearchContextProps.setCurrentPage(0);
      },
    };
  });

export default FilterStore;
